export function toggleSearchInput(e) {
  if (
    !e.target.classList.contains("fa-search") &&
    !e.target.classList.contains("navigation-search") &&
    !e.target.classList.contains("navigation-search__input")
  ) {
    const container = document.querySelector(".navigation-search.active");
    if (container && container.querySelector("input").value === "") {
      container.classList.remove("active");
    }
    return;
  }
  const container = e.target.classList.contains("fa-search")
    ? e.target.parentElement
    : e.target;
  if (container.classList.contains("active")) return;
  container.classList.add("active");
  container.querySelector("input").focus();
}
